import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesArticulos() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_articulos ?(
      <div className="container">
        <br />
        <br />
        <Row >
      
          <Col md={4} align="center">
            {user.menu_articulos ?(
            <Button href="/ListadoArticulos" className="botonesMenu" color="success">
              <i class="fas fa-tshirt fa-7x"></i>
              <br />
              <br />
              Modelos
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-tshirt fa-7x"></i>
            <br />
            <br />
            Modelos
          </Button> }
          </Col>
          <Col md={4} align="center">
            {user.menu_articulos ?(
            <Button href="/Lineas" className="botonesMenu" color="success">
              <i class="fas fa-bars fa-7x"></i>
              <br />
              <br />
              Lineas
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-bars fa-7x"></i>
            <br />
            <br />
            Lineas
          </Button> }
            </Col>
            <Col md={4} align="center">
            {user.menu_articulos ?(
            <Button href="/Temporadas" className="botonesMenu" color="success">
              <i class="far fa-copyright fa-7x"></i>
              <br />
              <br />
              Temporadas
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="far fa-copyright fa-7x"></i>
            <br />
            <br />
            Temporadas
          </Button> }
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4} align="center">
            {user.menu_articulos ?(
            <Button href="/Colecciones" className="botonesMenu" color="success">
              <i class="fas fa-calendar-alt fa-7x"></i>
              <br />
              <br />
              Colecciones
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-calendar-alt fa-7x"></i>
            <br />
            <br />
            Colecciones
          </Button> }
            </Col>
            <Col md={4} align="center">
            {user.menu_articulos ?(
            <Button href="/ListadoTallas" className="botonesMenu" color="success">
              <i class="fas fa-ruler-horizontal fa-7x"></i>
              <br />
              <br />
              Tallas
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-ruler-horizontal fa-7x"></i>
            <br />
            <br />
            Tallas
          </Button> }
            </Col>
          </Row>
         
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesArticulos;
